import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreateDeclaracionSituacionActividad from 'services/record/DeclaracionSituacionActividad/useCreateDeclaracionSituacionActividad';
import useUpdateDeclaracionSituacionActividadByID from 'services/record/DeclaracionSituacionActividad/useUpdateDeclaracionSituacionActividad';
import FormInputYesNo from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputYesNo';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import CnaeContributionAtEp from 'components/blocks/Delta/Inputs/CnaeContributionAtEp';
import FormInputCNAE from 'components/blocks/ManagementNewForms/Inputs/FormInputCNAE';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import FormInputRadioTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioTable';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF';

const DeclaracionSituacionActividad = ({ info, dataUser, onSuccess: _onSuccess }: { info: boolean; dataUser: any; onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createDeclaracionSituacionActividad, dataCreateDeclaracionSituacionActividad, errorCreateDeclaracionSituacionActividad, loadingCreateDeclaracionSituacionActividad, successCreateDeclaracionSituacionActividad } = useCreateDeclaracionSituacionActividad();
    const { dataUpdateDeclaracionSituacionActividadById, errorUpdateDeclaracionSituacionActividadById, loadingUpdateDeclaracionSituacionActividadById, successUpdateDeclaracionSituacionActividadById, updateDeclaracionSituacionActividadById } = useUpdateDeclaracionSituacionActividadByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    void _onSuccess;

    const watchProvinciaEstablecimiento = watch("Establecimiento.establecimiento_CodigoProvincia");
    const watchProvinciaDescEstablecimiento = watch("Establecimiento.establecimiento_ProvinciaDescripcion");
    const watchCommEstablecimiento = watch("Establecimiento.establecimiento_CodigoLocalidad");
    const watchCommDescEstablecimiento = watch("Establecimiento.establecimiento_LocalidadDescripcion");
    const titularidadValue = watch('Establecimiento.Titularidad');
    const gestionadoCeseValue = watch('Gestion.GestionadoCese');
    const personaGestionaValue = watch('Gestion.PersonaGestiona');
    const isTitularidadSi = titularidadValue === true;
    const isTitularidadNo = titularidadValue === false;
    const isGestionadoSinCese = gestionadoCeseValue === "0";
    const hasPersonaGestiona = personaGestionaValue !== null && personaGestionaValue !== undefined && personaGestionaValue !== "";
    const isPersonaGestionaFamiliar = personaGestionaValue === "0";
    const getValue = (...values: any[]) => values.find(value => value !== undefined && value !== null);



    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {
            const datosPersonales = getValue(data?.DatosPersonales, data?.datosPersonales) || {};
            const gestionadoNombre = getValue(data?.Gestionado_Nombre, data?.gestionado_Nombre, "");
            const gestionadoApellido1 = getValue(data?.Gestionado_Apellido1, data?.gestionado_Apellido1, "");
            const gestionadoApellido2 = getValue(data?.Gestionado_Apellido2, data?.gestionado_Apellido2, "");
            const gestionadoNombreCompletoLegacy = getValue(data?.Gestionado_NombreCompleto, data?.gestionado_NombreCompleto, "");
            const partesNombreCompletoLegacy = gestionadoNombreCompletoLegacy.split(' ').filter(Boolean);

            const gestionadoCese = getValue(data?.CeseActividad, data?.ceseActividad, null);
            reset({
                DatosPersonales: {
                    SolicitanteNombre: getValue(datosPersonales?.Nombre, datosPersonales?.nombre, ""),
                    SolicitanteApellido1: getValue(datosPersonales?.Apellido1, datosPersonales?.apellido1, ""),
                    SolicitanteApellido2: getValue(datosPersonales?.Apellido2, datosPersonales?.apellido2, ""),
                    SolicitanteIPF: getValue(datosPersonales?.IPF, datosPersonales?.ipf, ""),
                    SolicitanteIPFTipo: getValue(datosPersonales?.IPFTipo, datosPersonales?.ipfTipo)?.toString() || "1",

                    SolicitanteTelefono: getValue(datosPersonales?.Telefono, datosPersonales?.telefono, ""),
                    SolicitanteFijo: getValue(datosPersonales?.Fijo, datosPersonales?.fijo, ""),
                    SolicitanteDomicilio: getValue(datosPersonales?.Domicilio, datosPersonales?.domicilio, ""),
                    SolicitanteCodigoPostal: getValue(datosPersonales?.CodigoPostal, datosPersonales?.codigoPostal, ""),
                    SolicitanteProvincia: getValue(datosPersonales?.CodigoProvincia, datosPersonales?.codigoProvincia, ""),
                    SolicitanteProvinciaDescripcion: getValue(datosPersonales?.Provincia, datosPersonales?.ProvinciaDescripcion, datosPersonales?.provinciaDescripcion, ""),
                    SolicitanteComunidadCodigo: getValue(datosPersonales?.ComunidadCodigo, datosPersonales?.CodigoLocalidad, datosPersonales?.codigoLocalidad, ""),
                    SolicitanteComunidadCodigoDescripcion: getValue(datosPersonales?.ComunidadCodigoDescripcion, datosPersonales?.LocalidadDescripcion, datosPersonales?.localidadDescripcion, ""),
                    SolicitanteEmail: getValue(data?.Email, data?.email, ""),
                    SolicitanteFechaNacimiento: getValue(data?.FechaNacimiento, data?.fechaNacimiento, ""),
                    SolicitanteNumeroSS: getValue(datosPersonales?.NumeroSeguridadSocial, datosPersonales?.numeroSeguridadSocial, ""),
                    SolicitanteIRPF: getValue(data?.TipoIRPFVoluntario, data?.tipoIRPFVoluntario, ""),
                },

                Establecimiento: {
                    Titularidad: getValue(data?.Titularidad, data?.titularidad, null),
                    DeclaracionRegimenEspecial: getValue(data?.DeclaracionRegimenEspecial, data?.declaracionRegimenEspecial, ""),
                    establecimiento_Domicilio: getValue(data?.Establecimiento_Domicilio, data?.establecimiento_Domicilio, ""),
                    establecimiento_CodigoPostal: getValue(data?.Establecimiento_CodigoPostal, data?.establecimiento_CodigoPostal, ""),
                    establecimiento_ProvinciaDescripcion: getValue(data?.Establecimiento_ProvinciaDescripcion, data?.establecimiento_ProvinciaDescripcion, ""),
                    establecimiento_CodigoProvincia: getValue(data?.Establecimiento_CodigoProvincia, data?.establecimiento_CodigoProvincia, ""),
                    establecimiento_CodigoLocalidad: getValue(data?.Establecimiento_CodigoLocalidad, data?.establecimiento_CodigoLocalidad, ""),
                    establecimiento_LocalidadDescripcion: getValue(data?.Establecimiento_LocalidadDescripcion, data?.establecimiento_LocalidadDescripcion, ""),
                    CNAE2009: getValue(data?.Establecimiento_CNAEDescripcion, data?.establecimiento_CNAEDescripcion, ""),
                },

                Gestion: {
                    GestionadoCese: gestionadoCese === true ? "1" : "0",
                    PersonaGestiona: getValue(data?.Gestionado_Encargado, data?.gestionado_Encargado, ""),
                    PersonaGestionaNombre: gestionadoNombre || partesNombreCompletoLegacy[0] || "",
                    PersonaGestionaApellido1: gestionadoApellido1 || (partesNombreCompletoLegacy.length > 1 ? partesNombreCompletoLegacy[1] : ""),
                    PersonaGestionaApellido2: gestionadoApellido2 || (partesNombreCompletoLegacy.length > 2 ? partesNombreCompletoLegacy.slice(2).join(' ') : ""),
                    PersonaGestionaNumeroSeguridadSocial: getValue(data?.Gestionado_NumeroSeguridadSocial, data?.gestionado_NumeroSeguridadSocial, ""),
                    PersonaGestionaIPF: getValue(data?.Gestionado_IPF, data?.gestionado_IPF, ""),
                    PersonaGestionaIPFTipo: getValue(data?.Gestionado_IPFTipo, data?.gestionado_IPFTipo, "")?.toString() || "",
                    PersonaGestionaParentesco: getValue(data?.Gestionado_Parentesco, data?.gestionado_Parentesco, ""),
                },

                CNAE2009Code: getValue(data?.Establecimiento_CodigoCNAE, data?.establecimiento_CodigoCNAE, ""),
            })
        }
    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;
        const gestionadoNombre = (data?.Gestion?.PersonaGestionaNombre || '').trim() || null;
        const gestionadoApellido1 = (data?.Gestion?.PersonaGestionaApellido1 || '').trim() || null;
        const gestionadoApellido2 = (data?.Gestion?.PersonaGestionaApellido2 || '').trim() || null;
        const gestionadoCeseValue = data?.Gestion?.GestionadoCese;
        const ceseActividad = gestionadoCeseValue === "1";
        const gestionadoEncargado = data?.Gestion?.PersonaGestiona;

        const parseNullableInt = (value: any) => {
            if (value === null || value === undefined || value === "") return null;
            const parsed = Number(value);
            return Number.isNaN(parsed) ? null : parsed;
        };

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,
            Acepto: data?.Acepto ?? false,

            // -----------------------------------
            // DATOS PERSONALES
            // -----------------------------------
            DatosPersonales: {
                nombre: data?.DatosPersonales?.SolicitanteNombre || '',
                apellido1: data?.DatosPersonales?.SolicitanteApellido1 || '',
                apellido2: data?.DatosPersonales?.SolicitanteApellido2 || '',
                ipf: data?.DatosPersonales?.SolicitanteIPF || '',
                ipfTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,
                telefono: data?.DatosPersonales?.SolicitanteTelefono || '',
                fijo: data?.DatosPersonales?.SolicitanteFijo || '',
                domicilio: data?.DatosPersonales?.SolicitanteDomicilio || '',
                codigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || '',
                provinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
                codigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,

                codigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
                localidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,
                numeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || '',
            },

            Titularidad: data?.Establecimiento?.Titularidad ?? null,
            Establecimiento_Domicilio: data?.Establecimiento?.establecimiento_Domicilio || null,
            Establecimiento_CodigoPostal: data?.Establecimiento?.establecimiento_CodigoPostal || null,
            Establecimiento_ProvinciaDescripcion: data?.Establecimiento?.establecimiento_ProvinciaDescripcion || null,
            Establecimiento_CodigoProvincia: data?.Establecimiento?.establecimiento_CodigoProvincia || null,
            Establecimiento_CodigoLocalidad: data?.Establecimiento?.establecimiento_CodigoLocalidad || null,
            Establecimiento_LocalidadDescripcion: data?.Establecimiento?.establecimiento_LocalidadDescripcion || null,
            Establecimiento_CodigoCNAE: data?.CNAE2009Code || null,
            Establecimiento_CNAEDescripcion: data?.Establecimiento?.CNAE2009 || null,

            Gestionado_Encargado: parseNullableInt(gestionadoEncargado),
            Gestionado_Nombre: gestionadoNombre,
            Gestionado_Apellido1: gestionadoApellido1,
            Gestionado_Apellido2: gestionadoApellido2,
            Gestionado_IPF: data?.Gestion?.PersonaGestionaIPF || null,
            Gestionado_IPFTipo: parseNullableInt(data?.Gestion?.PersonaGestionaIPFTipo),
            Gestionado_NumeroSeguridadSocial: data?.Gestion?.PersonaGestionaNumeroSeguridadSocial || null,
            Gestionado_Parentesco: data?.Gestion?.PersonaGestionaParentesco || null,

            CeseActividad: ceseActividad,
            DeclaracionRegimenEspecial: data?.Establecimiento?.DeclaracionRegimenEspecial || null,
        }

        if (info) {
            createDeclaracionSituacionActividad(dataUser?.UsuarioId.toString(), prestacionId, datosEnvio, _onSuccess)
            setBloquearEnvio(true);
        } else {
            updateDeclaracionSituacionActividadById(dataUser?.Id, prestacionId, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={getValue(datosAPI?.EstadoFormulario, datosAPI?.estadoFormulario, dataUser?.EstadoFormulario, dataUser?.estadoFormulario)}
                    estadoFormularioDescripcion={getValue(datosAPI?.EstadoFormularioDescripcion, datosAPI?.estadoFormularioDescripcion, dataUser?.EstadoFormularioDescripcion, dataUser?.estadoFormularioDescripcion)}
                    fechaActualizacionEstado={getValue(datosAPI?.FechaActualizacionEstado, datosAPI?.fechaActualizacionEstado, dataUser?.FechaActualizacionEstado, dataUser?.fechaActualizacionEstado)}
                />

                <Loader activeLoader={loader || loadingCreateDeclaracionSituacionActividad || loadingUpdateDeclaracionSituacionActividadById} label="Cargando Formulario"></Loader>








                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <p className='text-info-legal paragraph  text-secondary  my-4'>

                    Resolución de 04/02/2004 del INSS y Resolución de 22/03/2004 del ISM, sobre cumplimiento por los trabajadores por cuenta propia de la
                    obligación establecida en Real Decreto 1273/2003, en la que se establece que la declaración deberá presentarse dentro de los 15 días siguientes
                    a la fecha de la baja médica, en el caso de incapacidad temporal y de los 15 días siguientes a la suspensión de la actividad, en los supuestos de
                    riesgo durante el embarazo.

                </p>
                <FormDatosPersonales activarSS={true} />

                <AccordionForm title={'Establecimiento Mercantil'} expandedInit={false} nombreError='Establecimiento' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputYesNo
                                    name="Establecimiento.Titularidad"
                                    title="Es titular de un establecimiento mercantil, industrial o de otra naturaleza:"
                                    required='Debe contestar si es titular de un establecimiento o no'
                                />

                                <AccordionDisplay dataUser={dataUser} visibility={isTitularidadNo} fields={['Establecimiento.DeclaracionRegimenEspecial']}>
                                    <FormInputText
                                        name='Establecimiento.DeclaracionRegimenEspecial'
                                        id='Establecimiento.DeclaracionRegimenEspecial'
                                        label='Por el contrario declara que se encuentra incluido en el Régimen Especial de Trabajadores por Cuenta Propia o Autónomos en razón de la actividad económica de:'
                                        req={isTitularidadNo ? 'Es obligatorio responder si se encuentra incluido en el Régimen Especial' : null}
                                        md={12}
                                        xl={12}
                                    />
                                </AccordionDisplay>

                                <AccordionDisplay
                                    dataUser={dataUser}
                                    visibility={isTitularidadSi}
                                    fields={[
                                        'Establecimiento.establecimiento_Domicilio',
                                        'Establecimiento.establecimiento_CodigoProvincia',
                                        'Establecimiento.establecimiento_ProvinciaDescripcion',
                                        'Establecimiento.establecimiento_CodigoLocalidad',
                                        'Establecimiento.establecimiento_LocalidadDescripcion',
                                        'CNAE2009Code',
                                        'Establecimiento.CNAE2009',
                                        'Establecimiento.CNAE2009Id'
                                    ]}
                                >
                                    <p className='paragraph mb-3 fs-5 fw-bold'>Dicho Establecimiento tiene su domicilio en: </p>
                                    <FormInputText
                                        name='Establecimiento.establecimiento_Domicilio'
                                        id='Establecimiento.establecimiento_Domicilio'
                                        label='Domicilio del establecimiento (Calle/Plaza/Avenida/...)'
                                        req={isTitularidadSi ? 'Es obligatorio rellenar el domicilio del establecimiento' : null}
                                        md={12}
                                        xl={12}
                                    />
                                    <div className="col-xl-6 col-md-6">
                                        <Province
                                            errors={errors}
                                            register={register}
                                            idCode={'Establecimiento.establecimiento_CodigoProvincia'}
                                            watchProvinceDescription={watchProvinciaDescEstablecimiento}
                                            idDescription={'Establecimiento.establecimiento_ProvinciaDescripcion'}
                                            watchProvinceCode={watchProvinciaEstablecimiento}
                                            setValue={setValue}
                                            required={isTitularidadSi ? 'Es obligatorio seleccionar una provincia del establecimiento' : null}
                                            disabled={false}
                                        />
                                    </div>
                                    <div className="col-xl-6 col-md-6 mb-3">
                                        <TestCommunity
                                            errors={errors}
                                            register={register}
                                            setValue={setValue}
                                            watchProvinceCode={watchProvinciaEstablecimiento}
                                            watchCommunityCode={watchCommEstablecimiento}
                                            watchCommunityDescription={watchCommDescEstablecimiento}
                                            idCode={'Establecimiento.establecimiento_CodigoLocalidad'}
                                            idDescription={'Establecimiento.establecimiento_LocalidadDescripcion'}
                                            filterByProvince={true}
                                            required={isTitularidadSi ? 'Es obligatorio seleccionar una localidad del establecimiento' : null}
                                            disabled={false}
                                        />
                                    </div>
                                    <FormInputCNAE
                                        name="CNAE2009Code"
                                        descriptionName="Establecimiento.CNAE2009"
                                        idName="Establecimiento.CNAE2009Id"
                                        label="CNAE"
                                        placeholder="CNAE para cotizacion AT/EP"
                                        required={isTitularidadSi ? "El CNAE es obligatorio" : null}
                                        disabled={false}
                                        xl={12}
                                        md={12}
                                        col={12}
                                    />

                                </AccordionDisplay>

                                <AccordionDisplay
                                    dataUser={dataUser}
                                    visibility={isTitularidadSi}
                                    fields={[
                                        'Gestion.GestionadoCese',
                                        'Gestion.PersonaGestiona',
                                        'Gestion.PersonaGestionaNombre',
                                        'Gestion.PersonaGestionaApellido1',
                                        'Gestion.PersonaGestionaApellido2',
                                        'Gestion.PersonaGestionaNumeroSeguridadSocial',
                                        'Gestion.PersonaGestionaIPF',
                                        'Gestion.PersonaGestionaIPFTipo',
                                        'Gestion.PersonaGestionaParentesco'
                                    ]}
                                >
                                    <p className='paragraph mb-3 fs-5 fw-bold'>Y que durante la situacion de incapacidad temporal / riesgo, la actividad queda gestionada por: </p>
                                    <FormInputRadioGroup
                                        name="Gestion.GestionadoCese"
                                        required={isTitularidadSi ? "Debe seleccionar si queda gestionado" : null}
                                        labels={["Gestionada por Familiar, Empleado del establecimiento u otra persona", "Cese temporal o definitivo"]}
                                        col={12}
                                        modal={["", "Cese temporal o definitivo de la actividad durante la situación de incapacidad temporal/riesgo durante el embarazo o durante la lactancia natural del titular del establecimiento"]}
                                    />

                                    <AccordionDisplay
                                        dataUser={dataUser}
                                        visibility={isGestionadoSinCese}
                                        fields={[
                                            'Gestion.PersonaGestiona',
                                            'Gestion.PersonaGestionaNombre',
                                            'Gestion.PersonaGestionaApellido1',
                                            'Gestion.PersonaGestionaApellido2',
                                            'Gestion.PersonaGestionaNumeroSeguridadSocial',
                                            'Gestion.PersonaGestionaIPF',
                                            'Gestion.PersonaGestionaIPFTipo',
                                            'Gestion.PersonaGestionaParentesco'
                                        ]}
                                    >

                                        <FormInputRadioGroup
                                            name="Gestion.PersonaGestiona"
                                            required={isTitularidadSi && isGestionadoSinCese ? "Debe seleccionar si queda gestionado" : null}
                                            labels={["Familiar", "Empleado", "Otra persona"]}
                                            col={12}

                                        />
                                        <AccordionDisplay
                                            dataUser={dataUser}
                                            visibility={isTitularidadSi && isGestionadoSinCese && hasPersonaGestiona}
                                            fields={[
                                                'Gestion.PersonaGestionaNombre',
                                                'Gestion.PersonaGestionaApellido1',
                                                'Gestion.PersonaGestionaApellido2',
                                                'Gestion.PersonaGestionaNumeroSeguridadSocial',
                                                'Gestion.PersonaGestionaIPF',
                                                'Gestion.PersonaGestionaIPFTipo'
                                            ]}
                                        >
                                            <FormInputText
                                                name='Gestion.PersonaGestionaNombre'
                                                id='Gestion.PersonaGestionaNombre'
                                                label='Nombre'
                                                req={isTitularidadSi && isGestionadoSinCese && hasPersonaGestiona ? 'Falta rellenar el campo Nombre de la persona gestionada' : null}
                                                md={4}
                                                xl={4}
                                            />
                                            <FormInputText
                                                name='Gestion.PersonaGestionaApellido1'
                                                id='Gestion.PersonaGestionaApellido1'
                                                label='Primer apellido'
                                                req={isTitularidadSi && isGestionadoSinCese && hasPersonaGestiona ? 'Falta rellenar el campo Primer apellido de la persona gestionada' : null}
                                                md={4}
                                                xl={4}
                                            />
                                            <FormInputText
                                                name='Gestion.PersonaGestionaApellido2'
                                                id='Gestion.PersonaGestionaApellido2'
                                                label='Segundo apellido'
                                                req={isTitularidadSi && isGestionadoSinCese && hasPersonaGestiona ? 'Falta rellenar el campo Segundo apellido de la persona gestionada' : null}
                                                md={4}
                                                xl={4}
                                            />
                                            <FormInputText
                                                name='Gestion.PersonaGestionaNumeroSeguridadSocial'
                                                id='Gestion.PersonaGestionaNumeroSeguridadSocial'
                                                label='Número de Seguridad Social'
                                                maxLength={12}
                                                pattern={/^[0-9]{1,12}$/}
                                                patternMessage='Solo se permiten números (máximo 12 dígitos)'
                                                req={isTitularidadSi && isGestionadoSinCese && hasPersonaGestiona ? 'Falta rellenar el campo Número de Seguridad Social de la persona gestionada' : null}
                                                md={6}
                                                xl={6}
                                            />
                                            <FormInputIPF
                                                name={'Gestion.PersonaGestionaIPF'}
                                                id={'Gestion.PersonaGestionaIPF'}
                                                label={'IPF (Identificación Personal Fisica)'} placeholder={''}
                                                req={isTitularidadSi && isGestionadoSinCese && hasPersonaGestiona ? 'Falta rellenar el campo IPF de la persona gestionada' : null}
                                                md={6}
                                                xl={6}
                                                disabled={false}
                                            />
                                        </AccordionDisplay>
                                        <AccordionDisplay
                                            dataUser={dataUser}
                                            visibility={isTitularidadSi && isGestionadoSinCese && isPersonaGestionaFamiliar}
                                            fields={['Gestion.PersonaGestionaParentesco']}
                                        >
                                            <FormInputText
                                                name='Gestion.PersonaGestionaParentesco'
                                                id='Gestion.PersonaGestionaParentesco'
                                                label='Parentesco'
                                                req={isTitularidadSi && isGestionadoSinCese && isPersonaGestionaFamiliar ? 'Falta rellenar el campo Parentesco de la persona gestionada' : null}
                                                md={12}
                                                xl={12}
                                            />
                                        </AccordionDisplay>
                                    </AccordionDisplay>

                                </AccordionDisplay>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>
















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    label='Con la firma de este documento, declaro bajo mi responsabilidad que son ciertos todos los datos que consigno en el mismo y quedo enterado de la
                    obligación de comunicar a la Mutua cualquier variación de los datos en él expresados, que pudieran producirse durante la percepción de la
                    prestación de Incapacidad Temporal'
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateDeclaracionSituacionActividad}
                    successUpdate={successUpdateDeclaracionSituacionActividadById}
                    errorCreate={errorCreateDeclaracionSituacionActividad}
                    errorUpdate={errorUpdateDeclaracionSituacionActividadById}
                    datosAPI={datosAPI}
                    info={info}
                    BloqueoForm={[2]}

                />


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default DeclaracionSituacionActividad
